import { createContext, useState, useMemo, ReactNode } from 'react';

interface OrderContextType {
  orderFound: string;
  setOrderFound: React.Dispatch<React.SetStateAction<string>>;
}

export const OrderContext = createContext<OrderContextType | undefined>(undefined);

interface OrderContextProviderProps {
  children: ReactNode;
}

export const OrderContextProvider: React.FC<OrderContextProviderProps> = ({ children }) => {
  const [orderFound, setOrderFound] = useState<string>('');

  // Memoize the context value to avoid re-creating the object on every render
  const contextValue = useMemo(() => ({ orderFound, setOrderFound }), [orderFound]);

  return <OrderContext.Provider value={contextValue}>{children}</OrderContext.Provider>;
};
